import { useMemo } from 'react';

import { useGetDatesQuery } from 'state/apiSlice';
import { useAppSelector } from 'state/hooks';
import { selectProject, selectTargetDate } from 'state/workflowSlice';

import { parseDate } from 'features/common/datetimeUtils';

export function useNextLastDay() {
  const targetDate = useAppSelector(selectTargetDate);
  const project_slug = useAppSelector(selectProject);
  const { currentData: datesInfo } = useGetDatesQuery(
    project_slug,
    { skip: !project_slug, pollingInterval: 3 * 60 * 60 * 1000 }, // every 3 hours
  );
  const memOutput = useMemo(() => {
    let nextDay: string;
    let lastDay: string;
    let nextDayAvailable = false;
    let lastDayAvailable = false;

    if (targetDate && datesInfo) {
      nextDay = parseDate(targetDate).add(1, 'day').format('YYYY-MM-DD');
      lastDay = parseDate(targetDate).subtract(1, 'day').format('YYYY-MM-DD');
      for (let i = 0; i < datesInfo.length; i++) {
        if (nextDay === datesInfo[i].date) {
          nextDayAvailable = true;
        }
        if (lastDay === datesInfo[i].date) {
          lastDayAvailable = true;
        }
      }
    }
    return { nextDay, lastDay, nextDayAvailable, lastDayAvailable };
  }, [targetDate, datesInfo]);

  return memOutput;
}
